var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.offers?.length > 0
    ? _c(
        "section",
        {
          class: [
            "remove-margin",
            "global-search-stories",
            { "hide-result-content": _vm.hideByDefault }
          ]
        },
        [
          _vm._l(_vm.getFirstThreeOffers, function(offer) {
            return _c(
              "article",
              {
                key: offer.id,
                staticClass: "global-search-single-story-container"
              },
              [
                _c("span", {
                  staticClass: "global-search-result-title",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.isTitleAndMatchTextCombined
                        ? _vm.getOfferTitle(offer)
                        : _vm.markKeyWord(_vm.getOfferTitle(offer))
                    )
                  },
                  on: {
                    click: function($event) {
                      return _vm.openOffer(offer)
                    }
                  }
                }),
                offer &&
                (_vm.isTitleAndMatchTextCombined ||
                  !_vm
                    .getOfferTitle(offer)
                    .toLowerCase()
                    .includes(
                      _vm.$store.getters
                        .getGlobalSearchResult("word")
                        .toLowerCase()
                    ))
                  ? _c("p", {
                      staticClass: "global-search-result-text",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.modifyText(_vm.getText(offer), 100)
                        )
                      },
                      on: {
                        click: function($event) {
                          return _vm.openOffer(offer)
                        }
                      }
                    })
                  : _vm._e()
              ]
            )
          }),
          _vm.offers.length >= 2 && !_vm.hideShowAllButton
            ? _c(
                "button",
                {
                  staticClass: "show-all",
                  on: {
                    click: function($event) {
                      return _vm.viewAll()
                    }
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        `${_vm.$t("globalSearchSections.showAll")} (${
                          _vm.offers.length
                        })`
                      ) +
                      " "
                  )
                ]
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }